import { StorageAction } from '@cast/openapi-stop';
import { DimensionChange } from 'features/cluster/storage-optimization/pv-events/types';
import { convertUnit } from '@cast/utils';
import round from 'lodash/round';

export const getActionOperationChanges = (
  action: StorageAction
): DimensionChange[] => {
  const {
    sizeBytes: currentSizeBytes,
    throughput: currentThroughput,
    iops: currentIops,
  } = action.currentDisk ?? {};
  const {
    sizeBytes: previousSizeBytes,
    throughput: previousThroughput,
    iops: previousIops,
  } = action.prevDisk ?? {};
  const operations = [];

  const currentSizeGiB = currentSizeBytes
    ? convertUnit(Number(currentSizeBytes), 'Bytes', 'GiB')
    : 0;
  const previousSizeGiB = previousSizeBytes
    ? convertUnit(Number(previousSizeBytes), 'Bytes', 'GiB')
    : 0;
  const numericalCurrentIops = currentIops ? Number(currentIops) : 0;
  const numericalPreviousIops = previousIops ? Number(previousIops) : 0;
  const numericalCurrentThroughput = currentThroughput
    ? Number(currentThroughput)
    : 0;
  const numericalPreviousThroughput = previousThroughput
    ? Number(previousThroughput)
    : 0;

  if (currentSizeGiB !== previousSizeGiB) {
    operations.push({
      id: action.operationId || Math.random().toString(),
      before: round(previousSizeGiB, 2),
      after: round(currentSizeGiB, 2),
      label: 'Capacity',
      unit: 'GiB',
    });
  }

  if (numericalPreviousIops !== numericalCurrentIops) {
    operations.push({
      id: action.operationId || Math.random().toString(),
      before: round(numericalPreviousIops, 2),
      after: round(numericalCurrentIops, 2),
      label: 'IOPS',
      unit: 'IOPS',
    });
  }

  if (numericalPreviousThroughput !== numericalCurrentThroughput) {
    operations.push({
      id: action.operationId || Math.random().toString(),
      before: round(numericalPreviousThroughput, 2),
      after: round(numericalCurrentThroughput, 2),
      label: 'Throughput',
      unit: 'MiB/s',
    });
  }

  return operations;
};
